var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var transformAnswersToEn = function (userAnswers, planQuestionsEN) {
    var finalAnswers = userAnswers.map(function (_a) {
        var questionId = _a.questionId, answerId = _a.answerId;
        var currentENQuestion = planQuestionsEN.find(function (question) { return question.questionId === questionId; });
        var answers = currentENQuestion.answers.find(function (answerEN) { return answerEN.answerId === answerId; });
        return __assign(__assign({}, answers), { questionId: currentENQuestion.questionId });
    });
    return finalAnswers;
};
export default transformAnswersToEn;
//# sourceMappingURL=transformAnswerstoEn.js.map